import Index from './Index.vue';
import Search from './Search.vue';
import Departures from './Departures';
import Returns from './Returns';
import Passengers from './Passengers';
import Options from './Options';
import Summary from './Summary';
import Confirmation from './Confirmation';

export default { Index, Search, Departures, Returns, Passengers, Options, Summary, Confirmation };
